import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const useRelayState = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  return () =>
    navigate(
      // For some reason, it's not always written the same way....
      searchParams.get("relay_state") ?? searchParams.get("RelayState") ?? "/"
    );
};

export const loginErrorCodes = {
  user_not_active:
    "com.avispl.symphony.auth.error.SymphonyUserNotActiveException",
  user_not_found: "com.avispl.symphony.error.UserNotFoundException",
  user_deactivated_due_to_inactivity:
    "com.avispl.symphony.auth.error.SymphonyUserDeactivatedDueToInactivityException",
  user_account_not_active:
    "com.avispl.symphony.auth.error.SymphonyAccountNotActiveException",
  user_account_not_allowed:
    "SAML Sign in is not allowed by account configuration",
  user_login_failed: "Login failed, verify your credentials and try again.",
  user_account_is_locked:
    "com.avispl.symphony.auth.common.error.SymphonyLoginLockoutException",
  token_expired:
    "Something went wrong and server couldn't process your request.",
  logout_failed:
    "Something went wrong and server couldn't process your request.",
  "": "Something went wrong and server couldn't process your request.",
  user_account_not_using_saml:
    "Your account is not configured for SAML SSO. Please use Symphony authentication.",
  user_unauthorized:
    "Something went wrong and server couldn't process your request.",
};

export const useErrorCode = () => {
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get("errorcode") ?? "";
  return loginErrorCodes[errorCode as keyof typeof loginErrorCodes];
};
